<template>
  <transition name="perload">
    <div id="app">
        <router-view></router-view>
    </div>
  </transition>

</template>

<script>

export default {
    name: 'app',
    mounted(){
        document.getElementById('app').style.display = 'block';
        document.getElementById('appLoading').style.display = 'none';
    }
}
</script>

<style>
.perload-enter-active, .perload-leave-active {
  transition: opacity .5s;
}
.perload-enter, .perload-leave-to {
  opacity: 0;
}
</style>
